// @ts-check
import React from 'react'
import propOr from 'ramda/src/propOr'
import { useTranslation } from 'react-i18next'
import { Message } from '../../ui'
import { useStore } from '../../StateProvider'
import { ResendEmailError } from '../ResendEmailError/ResendEmailError'

/**
 * @param {{error?: ErrorCommon | {}}} props
 */
const ErrorMessage = ({ error = {} }) => {
  const { t } = useTranslation()
  const [
    {
      whitelabel: { email, phone }
    }
  ] = useStore()
  return (
    <Message title={propOr(t('createAccount.cantBeCreated'), 'message', error)} type='failed'>
      {('code' in error && error.code === 1004)
        ? <ResendEmailError />
        : <>{t('createAccount.contactSupport')} <a href={`mailto:${email}`}>{email}</a>, {phone}</>}
    </Message>
  )
}

export { ErrorMessage }
